export const cleanupClientSpecificData = (previousClientId?: string | null) => {
  // List of localStorage keys to preserve
  const preserveKeys = [
    'i18nextLng',           // Language preference
    'userViewPreference',   // Table/grid view preference
    'showPriceAnalysis',    // Analysis panel visibility
    'activeAnalysisTab'     // Active analysis tab
  ];

  // Get all localStorage keys
  const allKeys = Object.keys(localStorage);

  // Clear client-specific data
  allKeys.forEach(key => {
    // Skip preserved keys
    if (preserveKeys.includes(key)) {
      return;
    }

    // Clear comparison products for previous client
    if (previousClientId && key === `comparisonProducts_${previousClientId}`) {
      localStorage.removeItem(key);
      return;
    }

    // Clear all column preferences (table names are client-specific)
    if (key.startsWith('columnPreferences_')) {
      localStorage.removeItem(key);
      return;
    }

    // Clear selected client (legacy: ahora vive en sessionStorage,
    // pero limpiamos también localStorage por compatibilidad).
    if (key === 'selectedClient') {
      localStorage.removeItem(key);
      return;
    }

    // Clear any comparison products (in case clientId wasn't provided)
    if (key.startsWith('comparisonProducts_')) {
      localStorage.removeItem(key);
      return;
    }

    // Clear temporary admin panel flag if exists
    if (key === 'openAdminPanel') {
      localStorage.removeItem(key);
      return;
    }
  });

  console.log('🧹 Cleaned up client-specific localStorage data');
};

export const cleanupOnLogout = () => {
  // On logout, clear everything except language preference
  const language = localStorage.getItem('i18nextLng');
  localStorage.clear();
  if (language) {
    localStorage.setItem('i18nextLng', language);
  }
  // sessionStorage también: el cliente activo (multi-tab fix) vive ahí.
  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }
  console.log('🧹 Cleaned up all localStorage data on logout');
};